import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Meta = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = "Unicon | Emission Testing Services for Compliance & Efficiency"; 
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Helmet>
      <title>Unicon | Emission Testing Services for Compliance & Efficiency</title>
      <meta name="title" content="Unicon Emission Testing Services for Compliance & Efficiency"/>
<meta name="description" content="Unicon provides emission testing services to ensure regulatory compliance, reduce pollution, and enhance operational efficiency in industrial environments"/>
<meta name="keywords" content="Best Emission Testing Services"/>
<meta name="robots" content="index,follow"/>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
<meta name="language" content="English"/>
<meta property="og:title" content="Unicon Emission Testing Services for Compliance & Efficiency"/>
<meta property="og:site_name" content="Unicon Emission Testing"/>
<meta property="og:url" content="https://www.uniconinter.com/emission-testing"/>
<meta property="og:description" content="Unicon provides emission testing services to ensure regulatory compliance, reduce pollution, and enhance operational efficiency in industrial environments"/>
<meta property="og:type" content="product"/>
<meta property="og:image" content="https://www.uniconinter.com/images/services/emission-testing/emission-main.jpg"/>

    </Helmet>
  );
};

export default Meta;
